var _style, _path, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _defs2, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 23.64",
    style: {
      enableBackground: "new 0 0 120 23.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0073AF;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#014B66;}\r\n\t.st2{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#024C67;}\r\n\t.st3{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#024D68;}\r\n\t.st4{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#024E69;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#024F6A;}\r\n\t.st6{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03506C;}\r\n\t.st7{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04516C;}\r\n\t.st8{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04526D;}\r\n\t.st9{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04526E;}\r\n\t.st10{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04536E;}\r\n\t.st11{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03546F;}\r\n\t.st12{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#035570;}\r\n\t.st13{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#015671;}\r\n\t.st14{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#015772;}\r\n\t.st15{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#025873;}\r\n\t.st16{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#015974;}\r\n\t.st17{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#025A76;}\r\n\t.st18{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#025B77;}\r\n\t.st19{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#015C78;}\r\n\t.st20{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#005D79;}\r\n\t.st21{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#005E7A;}\r\n\t.st22{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00607B;}\r\n\t.st23{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#005F7C;}\r\n\t.st24{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00617D;}\r\n\t.st25{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00617E;}\r\n\t.st26{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00637E;}\r\n\t.st27{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00647F;}\r\n\t.st28{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006480;}\r\n\t.st29{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006681;}\r\n\t.st30{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006682;}\r\n\t.st31{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006782;}\r\n\t.st32{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006883;}\r\n\t.st33{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006A84;}\r\n\t.st34{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006A85;}\r\n\t.st35{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006B86;}\r\n\t.st36{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006C87;}\r\n\t.st37{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006C88;}\r\n\t.st38{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#006D89;}\r\n\t.st39{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#016F8A;}\r\n\t.st40{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03708B;}\r\n\t.st41{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04718C;}\r\n\t.st42{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04728C;}\r\n\t.st43{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04738D;}\r\n\t.st44{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03748E;}\r\n\t.st45{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#02758F;}\r\n\t.st46{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#037690;}\r\n\t.st47{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#037791;}\r\n\t.st48{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#027892;}\r\n\t.st49{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#027993;}\r\n\t.st50{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#017A94;}\r\n\t.st51{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#027A95;}\r\n\t.st52{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#017B96;}\r\n\t.st53{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#007C97;}\r\n\t.st54{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D97;}\r\n\t.st55{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D98;}\r\n\t.st56{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D9A;}\r\n\t.st57{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#017F99;}\r\n\t.st58{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#017E9B;}\r\n\t.st59{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#01809B;}\r\n\t.st60{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#01809C;}\r\n\t.st61{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03809B;}\r\n\t.st62{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#03809C;}\r\n\t.st63{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04819C;}\r\n\t.st64{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04819D;}\r\n\t.st65{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04829D;}\r\n\t.st66{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#05829E;}\r\n\t.st67{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04839E;}\r\n\t.st68{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04839F;}\r\n\t.st69{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#04849F;}\r\n\t.st70{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0484A0;}\r\n\t.st71{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0485A0;}\r\n\t.st72{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0485A1;}\r\n\t.st73{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0586A1;}\r\n\t.st74{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0586A2;}\r\n\t.st75{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0587A2;}\r\n\t.st76{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0587A3;}\r\n\t.st77{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0688A3;}\r\n\t.st78{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0688A4;}\r\n\t.st79{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0789A4;}\r\n\t.st80{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0789A5;}\r\n\t.st81{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#078AA5;}\r\n\t.st82{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#078AA6;}\r\n\t.st83{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#068BA6;}\r\n\t.st84{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#068BA7;}\r\n\t.st85{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#058CA7;}\r\n\t.st86{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#058CA8;}\r\n\t.st87{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#048DA8;}\r\n\t.st88{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#048DA9;}\r\n\t.st89{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#028EA9;}\r\n\t.st90{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#028EAA;}\r\n\t.st91{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#018FAA;}\r\n\t.st92{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#018FAB;}\r\n\t.st93{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0190AB;}\r\n\t.st94{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0190AC;}\r\n\t.st95{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0091AC;}\r\n\t.st96{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0091AD;}\r\n\t.st97{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0092AD;}\r\n\t.st98{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0092AE;}\r\n\t.st99{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0193AE;}\r\n\t.st100{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0093AF;}\r\n\t.st101{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0294AF;}\r\n\t.st102{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0194B0;}\r\n\t.st103{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0295B0;}\r\n\t.st104{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0195B1;}\r\n\t.st105{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0096B1;}\r\n\t.st106{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0096B2;}\r\n\t.st107{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0097B3;}\r\n\t.st108{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0098B3;}\r\n\t.st109{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0098B4;}\r\n\t.st110{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#0099B5;}\r\n\t.st111{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009AB5;}\r\n\t.st112{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009AB6;}\r\n\t.st113{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009BB7;}\r\n\t.st114{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009CB8;}\r\n\t.st115{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009DB9;}\r\n\t.st116{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009EBA;}\r\n\t.st117{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#009FBB;}\r\n\t.st118{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A0BC;}\r\n\t.st119{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A1BD;}\r\n\t.st120{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A2BE;}\r\n\t.st121{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A3BF;}\r\n\t.st122{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A4C0;}\r\n\t.st123{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A5C2;}\r\n\t.st124{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A6C3;}\r\n\t.st125{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A7C4;}\r\n\t.st126{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A8C5;}\r\n\t.st127{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A9C6;}\r\n\t.st128{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00AAC7;}\r\n\t.st129{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00ABC8;}\r\n\t.st130{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#00ACC9;}\r\n\t.st131{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#014B66;}\r\n\t.st132{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#024C67;}\r\n\t.st133{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#024D68;}\r\n\t.st134{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#024E69;}\r\n\t.st135{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#024F6A;}\r\n\t.st136{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03506C;}\r\n\t.st137{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04516C;}\r\n\t.st138{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04526D;}\r\n\t.st139{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04526E;}\r\n\t.st140{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04536E;}\r\n\t.st141{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03546F;}\r\n\t.st142{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#035570;}\r\n\t.st143{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#015671;}\r\n\t.st144{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#015772;}\r\n\t.st145{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#025873;}\r\n\t.st146{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#015974;}\r\n\t.st147{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#025A76;}\r\n\t.st148{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#025B77;}\r\n\t.st149{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#015C78;}\r\n\t.st150{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#005D79;}\r\n\t.st151{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#005E7A;}\r\n\t.st152{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00607B;}\r\n\t.st153{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#005F7C;}\r\n\t.st154{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00617D;}\r\n\t.st155{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00617E;}\r\n\t.st156{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00637E;}\r\n\t.st157{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00647F;}\r\n\t.st158{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006480;}\r\n\t.st159{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006681;}\r\n\t.st160{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006682;}\r\n\t.st161{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006782;}\r\n\t.st162{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006883;}\r\n\t.st163{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006A84;}\r\n\t.st164{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006A85;}\r\n\t.st165{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006B86;}\r\n\t.st166{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006C87;}\r\n\t.st167{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006C88;}\r\n\t.st168{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#006D89;}\r\n\t.st169{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#016F8A;}\r\n\t.st170{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03708B;}\r\n\t.st171{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04718C;}\r\n\t.st172{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04728C;}\r\n\t.st173{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04738D;}\r\n\t.st174{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03748E;}\r\n\t.st175{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#02758F;}\r\n\t.st176{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#037690;}\r\n\t.st177{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#037791;}\r\n\t.st178{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#027892;}\r\n\t.st179{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#027993;}\r\n\t.st180{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#017A94;}\r\n\t.st181{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#027A95;}\r\n\t.st182{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#017B96;}\r\n\t.st183{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#007C97;}\r\n\t.st184{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D97;}\r\n\t.st185{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D98;}\r\n\t.st186{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#007D9A;}\r\n\t.st187{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#017F99;}\r\n\t.st188{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#017E9B;}\r\n\t.st189{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#01809B;}\r\n\t.st190{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#01809C;}\r\n\t.st191{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03809B;}\r\n\t.st192{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#03809C;}\r\n\t.st193{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04819C;}\r\n\t.st194{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04819D;}\r\n\t.st195{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04829D;}\r\n\t.st196{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#05829E;}\r\n\t.st197{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04839E;}\r\n\t.st198{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04839F;}\r\n\t.st199{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#04849F;}\r\n\t.st200{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0484A0;}\r\n\t.st201{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0485A0;}\r\n\t.st202{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0485A1;}\r\n\t.st203{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0586A1;}\r\n\t.st204{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0586A2;}\r\n\t.st205{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0587A2;}\r\n\t.st206{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0587A3;}\r\n\t.st207{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0688A3;}\r\n\t.st208{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0688A4;}\r\n\t.st209{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0789A4;}\r\n\t.st210{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0789A5;}\r\n\t.st211{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#078AA5;}\r\n\t.st212{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#078AA6;}\r\n\t.st213{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#068BA6;}\r\n\t.st214{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#068BA7;}\r\n\t.st215{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#058CA7;}\r\n\t.st216{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#058CA8;}\r\n\t.st217{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#048DA8;}\r\n\t.st218{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#048DA9;}\r\n\t.st219{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#028EA9;}\r\n\t.st220{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#028EAA;}\r\n\t.st221{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#018FAA;}\r\n\t.st222{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#018FAB;}\r\n\t.st223{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0190AB;}\r\n\t.st224{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0190AC;}\r\n\t.st225{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0091AC;}\r\n\t.st226{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0091AD;}\r\n\t.st227{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0092AD;}\r\n\t.st228{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0092AE;}\r\n\t.st229{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0193AE;}\r\n\t.st230{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0093AF;}\r\n\t.st231{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0294AF;}\r\n\t.st232{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0194B0;}\r\n\t.st233{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0295B0;}\r\n\t.st234{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0195B1;}\r\n\t.st235{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0096B1;}\r\n\t.st236{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0096B2;}\r\n\t.st237{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0097B3;}\r\n\t.st238{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0098B3;}\r\n\t.st239{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0098B4;}\r\n\t.st240{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#0099B5;}\r\n\t.st241{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009AB5;}\r\n\t.st242{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009AB6;}\r\n\t.st243{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009BB7;}\r\n\t.st244{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009CB8;}\r\n\t.st245{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009DB9;}\r\n\t.st246{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009EBA;}\r\n\t.st247{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#009FBB;}\r\n\t.st248{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A0BC;}\r\n\t.st249{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A1BD;}\r\n\t.st250{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A2BE;}\r\n\t.st251{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A3BF;}\r\n\t.st252{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A4C0;}\r\n\t.st253{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A5C2;}\r\n\t.st254{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A6C3;}\r\n\t.st255{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A7C4;}\r\n\t.st256{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A8C5;}\r\n\t.st257{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00A9C6;}\r\n\t.st258{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00AAC7;}\r\n\t.st259{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00ABC8;}\r\n\t.st260{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#00ACC9;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.22,1.4c-0.35,0-0.71,0-1.06,0c-0.35,0-0.71,0-0.94,0h-2.6c0,0.35-15,3.54-15,18.43h5.79l0,0 c0-1.3,0.12-2.48,0.47-3.54h8.74v3.54h5.79v-8.74l6.38,8.74h4.49l6.14-8.27v8.27h5.79v-3.78c2.01,2.48,5.31,4.13,9.09,4.13 c4.25,0,8.03-2.13,9.92-5.2v4.84H105v-3.54h8.74c0.35,1.06,0.47,2.24,0.47,3.54l0,0H120c0-14.88-15-18.07-15-18.43h-2.6 c-0.24,0-0.59,0-0.94,0c-0.35,0-0.71,0-1.06,0h-1.18v0.12v3.07v1.18C97.32,2.7,93.54,0.7,89.29,0.7c-3.78,0-7.09,1.65-9.09,4.13 V1.4h-0.59h-5.2h-0.24l-8.15,10.75L57.99,1.4H57.4H56.22z M99.21,12.62h-6.02c-0.83,1.3-2.36,2.24-4.25,2.24 c-2.6,0-4.72-2.01-4.72-4.49c0-2.48,2.13-4.49,4.72-4.49c1.89,0,3.54,1.06,4.37,2.48h5.91V12.62z M111.97,12.51 c-2.13-3.31-5.2-5.43-6.97-6.02v6.02H111.97z M44.65,12.51c2.13-3.31,5.2-5.43,6.97-6.02v6.02H44.65z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0,10.97h4.13c-0.12,5.08,1.89,8.27,4.49,10.16c2.95,2.24,6.73,3.07,10.39,2.13 c1.18-0.35,2.48-0.83,3.78-1.65c-5.91-2.95-9.57-6.5-10.28-10.63h3.9L8.15,2.94L0,10.97z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.35,24.55 0.24,23.73 22.8,23.25 22.91,24.08  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0.24,23.85 0.24,23.61 22.8,23.14 22.8,23.25  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "0.24,23.73 0.24,23.49 22.8,23.02 22.8,23.14  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "0.24,23.61 0.24,23.37 22.8,22.9 22.8,23.02  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0.24,23.49 0.24,23.25 22.8,22.78 22.8,22.9  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "0.24,23.37 0.24,23.14 22.8,22.66 22.8,22.78  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "0.24,23.25 0.24,23.02 22.8,22.55 22.8,22.66  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "0.24,23.14 0.24,22.9 22.8,22.43 22.8,22.55  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "0.24,23.02 0.24,22.78 22.8,22.31 22.8,22.43  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "0.24,22.9 0.24,22.66 22.8,22.19 22.8,22.31  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "0.24,22.78 0.24,22.55 22.8,22.07 22.8,22.19  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "0.24,22.66 0.24,22.43 22.8,21.96 22.8,22.07  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "0.24,22.55 0.24,22.31 22.8,21.84 22.8,21.96  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "0.24,22.43 0.24,22.19 22.8,21.72 22.8,21.84  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "0.24,22.31 0.24,22.07 22.8,21.6 22.8,21.72  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "0.24,22.19 0.24,21.96 22.8,21.48 22.8,21.6  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "0.24,22.07 0.24,21.84 22.8,21.37 22.8,21.48  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "0.24,21.96 0.24,21.72 22.8,21.25 22.8,21.37  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "0.24,21.84 0.24,21.6 22.8,21.13 22.8,21.25  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "0.24,21.72 0.24,21.48 22.8,21.01 22.8,21.13  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "0.24,21.6 0.24,21.37 22.8,20.89 22.8,21.01  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "0.24,21.48 0.24,21.25 22.8,20.77 22.8,20.89  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "0.24,21.37 0.24,21.13 22.8,20.66 22.8,20.77  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "0.24,21.25 0.24,21.01 22.8,20.54 22.8,20.66  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "0.24,21.13 0.24,20.89 22.8,20.42 22.8,20.54  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "0.24,21.01 0.24,20.77 22.8,20.3 22.8,20.42  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "0.24,20.89 0.24,20.66 22.8,20.18 22.8,20.3  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "0.24,20.77 0.24,20.54 22.8,20.07 22.8,20.18  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "0.24,20.66 0.24,20.42 22.8,19.95 22.8,20.07  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "0.24,20.54 0.24,20.3 22.8,19.83 22.8,19.95  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "0.24,20.42 0.24,20.18 22.8,19.71 22.8,19.83  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "0.24,20.3 0.24,20.07 22.8,19.59 22.8,19.71  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "0.24,20.18 0.24,19.95 22.8,19.48 22.8,19.59  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "0.24,20.07 0.24,19.83 22.8,19.36 22.8,19.48  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "0.24,19.95 0.24,19.71 22.8,19.24 22.8,19.36  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "0.24,19.83 0.24,19.59 22.8,19.12 22.8,19.24  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "0.24,19.71 0.24,19.48 22.8,19 22.8,19.12  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "0.24,19.59 0.24,19.36 22.8,18.88 22.8,19  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "0.24,19.48 0.24,19.24 22.8,18.77 22.8,18.88  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "0.24,19.36 0.24,19.12 22.8,18.65 22.8,18.77  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "0.24,19.24 0.24,19 22.8,18.53 22.8,18.65  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "0.24,19.12 0.24,18.88 22.8,18.41 22.8,18.53  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "0.24,19 0.24,18.77 22.8,18.29 22.8,18.41  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "0.24,18.88 0.24,18.65 22.68,18.18 22.8,18.29  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "0.24,18.77 0.12,18.53 22.68,18.06 22.68,18.18  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "0.24,18.65 0.12,18.41 22.68,17.94 22.68,18.06  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "0.12,18.53 0.12,18.29 22.68,17.82 22.68,17.94  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "0.12,18.41 0.12,18.18 22.68,17.7 22.68,17.82  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "0.12,18.29 0.12,18.06 22.68,17.59 22.68,17.7  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "0.12,18.18 0.12,17.94 22.68,17.47 22.68,17.59  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "0.12,18.06 0.12,17.82 22.68,17.35 22.68,17.47  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "0.12,17.94 0.12,17.7 22.68,17.23 22.68,17.35  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "0.12,17.82 0.12,17.59 22.68,17.11 22.68,17.23  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "0.12,17.7 0.12,17.47 22.68,16.99 22.68,17.11  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "0.12,17.59 0.12,17.35 22.68,16.88 22.68,16.99  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "0.12,17.47 0.12,17.23 22.68,16.76 22.68,16.88  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "0.12,17.35 0.12,17.11 22.68,16.64 22.68,16.76  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "0.12,17.23 0.12,16.99 22.68,16.52 22.68,16.64  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "0.12,17.11 0.12,16.88 22.68,16.4 22.68,16.52  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "0.12,16.99 0.12,16.76 22.68,16.29 22.68,16.4  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "0.12,16.88 0.12,16.64 22.68,16.17 22.68,16.29  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "0.12,16.76 0.12,16.52 22.68,16.05 22.68,16.17  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "0.12,16.64 0.12,16.4 22.68,15.93 22.68,16.05  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "0.12,16.52 0.12,16.29 22.68,15.81 22.68,15.93  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "0.12,16.4 0.12,16.17 22.68,15.7 22.68,15.81  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "0.12,16.29 0.12,16.05 22.68,15.58 22.68,15.7  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "0.12,16.17 0.12,15.93 22.68,15.46 22.68,15.58  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "0.12,16.05 0.12,15.81 22.68,15.34 22.68,15.46  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "0.12,15.93 0.12,15.7 22.68,15.22 22.68,15.34  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "0.12,15.81 0.12,15.58 22.68,15.11 22.68,15.22  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "0.12,15.7 0.12,15.46 22.68,14.99 22.68,15.11  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "0.12,15.58 0.12,15.34 22.68,14.87 22.68,14.99  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "0.12,15.46 0.12,15.22 22.68,14.75 22.68,14.87  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "0.12,15.34 0.12,15.11 22.68,14.63 22.68,14.75  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "0.12,15.22 0.12,14.99 22.68,14.51 22.68,14.63  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "0.12,15.11 0.12,14.87 22.68,14.4 22.68,14.51  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "0.12,14.99 0.12,14.75 22.68,14.28 22.68,14.4  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "0.12,14.87 0.12,14.63 22.68,14.16 22.68,14.28  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "0.12,14.75 0.12,14.51 22.68,14.04 22.68,14.16  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "0.12,14.63 0.12,14.4 22.68,13.92 22.68,14.04  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "0.12,14.51 0.12,14.28 22.68,13.81 22.68,13.92  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "0.12,14.4 0.12,14.16 22.68,13.69 22.68,13.81  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "0.12,14.28 0.12,14.04 22.68,13.57 22.68,13.69  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "0.12,14.16 0.12,13.92 22.68,13.45 22.68,13.57  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "0.12,14.04 0.12,13.81 22.68,13.33 22.68,13.45  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "0.12,13.92 0.12,13.69 22.68,13.22 22.68,13.33  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "0.12,13.81 0.12,13.57 22.68,13.1 22.68,13.22  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "0.12,13.69 0.12,13.45 22.68,12.98 22.68,13.1  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "0.12,13.57 0.12,13.33 22.68,12.86 22.68,12.98  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "0.12,13.45 0.12,13.22 22.56,12.74 22.68,12.86  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "0.12,13.33 0,13.1 22.56,12.62 22.56,12.74  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "0.12,13.22 0,12.98 22.56,12.51 22.56,12.62  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "0,13.1 0,12.86 22.56,12.39 22.56,12.51  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "0,12.98 0,12.74 22.56,12.27 22.56,12.39  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "0,12.86 0,12.62 22.56,12.15 22.56,12.27  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "0,12.74 0,12.51 22.56,12.03 22.56,12.15  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "0,12.62 0,12.39 22.56,11.92 22.56,12.03  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "0,12.51 0,12.27 22.56,11.8 22.56,11.92  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "0,12.39 0,12.15 22.56,11.68 22.56,11.8  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "0,12.27 0,12.03 22.56,11.56 22.56,11.68  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "0,12.15 0,11.92 22.56,11.44 22.56,11.56  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "0,12.03 0,11.8 22.56,11.33 22.56,11.44  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "0,11.92 0,11.68 22.56,11.21 22.56,11.33  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "0,11.8 0,11.56 22.56,11.09 22.56,11.21  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "0,11.68 0,11.44 22.56,10.97 22.56,11.09  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "0,11.56 0,11.33 22.56,10.85 22.56,10.97  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "0,11.44 0,11.21 22.56,10.74 22.56,10.85  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "0,11.33 0,11.09 22.56,10.62 22.56,10.74  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "0,11.21 0,10.97 22.56,10.5 22.56,10.62  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "0,11.09 0,10.85 22.56,10.38 22.56,10.5  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "0,10.97 0,10.74 22.56,10.26 22.56,10.38  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "0,10.85 0,10.62 22.56,10.14 22.56,10.26  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "0,10.74 0,10.5 22.56,10.03 22.56,10.14  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "0,10.62 0,10.38 22.56,9.91 22.56,10.03  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "0,10.5 0,10.26 22.56,9.79 22.56,9.91  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "0,10.38 0,10.14 22.56,9.67 22.56,9.79  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "0,10.26 0,10.03 22.56,9.55 22.56,9.67  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "0,10.14 0,9.91 22.56,9.44 22.56,9.55  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "0,10.03 0,9.79 22.56,9.32 22.56,9.44  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "0,9.91 0,9.67 22.56,9.2 22.56,9.32  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "0,9.79 0,9.55 22.56,9.08 22.56,9.2  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "0,9.67 0,9.44 22.56,8.96 22.56,9.08  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "0,9.55 0,9.32 22.56,8.85 22.56,8.96  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "0,9.44 0,9.2 22.56,8.73 22.56,8.85  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "0,9.32 0,9.08 22.56,8.61 22.56,8.73  "
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "0,9.2 0,8.96 22.56,8.49 22.56,8.61  "
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "0,9.08 0,8.85 22.56,8.37 22.56,8.49  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "0,8.96 0,8.73 22.56,8.25 22.56,8.37  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "0,8.85 0,8.61 22.56,8.14 22.56,8.25  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "0,8.73 0,8.49 22.56,8.02 22.56,8.14  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "0,8.61 0,8.37 22.56,7.9 22.56,8.02  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "0,8.49 0,8.25 22.56,7.78 22.56,7.9  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "0,8.37 0,8.14 22.56,7.66 22.56,7.78  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "0,8.25 0,8.02 22.56,7.55 22.56,7.66  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "0,8.14 0,7.9 22.44,7.43 22.56,7.55  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "0,8.02 0,7.78 22.44,7.31 22.56,7.43  "
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "0,7.9 -0.12,7.66 22.44,7.19 22.44,7.31  "
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "-0.12,7.78 -0.12,7.55 22.44,7.07 22.44,7.19  "
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "-0.12,7.66 -0.12,7.43 22.44,6.96 22.44,7.07  "
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "-0.12,7.55 -0.12,7.31 22.44,6.84 22.44,6.96  "
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "-0.12,7.43 -0.12,7.19 22.44,6.72 22.44,6.84  "
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "-0.12,7.31 -0.12,7.07 22.44,6.6 22.44,6.72  "
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "-0.12,7.19 -0.12,6.96 22.44,6.48 22.44,6.6  "
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "-0.12,7.07 -0.12,6.84 22.44,6.37 22.44,6.48  "
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "-0.12,6.96 -0.12,6.72 22.44,6.25 22.44,6.37  "
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "-0.12,6.84 -0.12,6.6 22.44,6.13 22.44,6.25  "
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "-0.12,6.72 -0.12,6.48 22.44,6.01 22.44,6.13  "
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "-0.12,6.6 -0.12,6.37 22.44,5.89 22.44,6.01  "
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "-0.12,6.48 -0.12,6.25 22.44,5.77 22.44,5.89  "
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "-0.12,6.37 -0.12,6.13 22.44,5.66 22.44,5.77  "
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "-0.12,6.25 -0.12,6.01 22.44,5.54 22.44,5.66  "
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "-0.12,6.13 -0.12,5.89 22.44,5.42 22.44,5.54  "
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "-0.12,6.01 -0.12,5.77 22.44,5.3 22.44,5.42  "
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "-0.12,5.89 -0.12,5.66 22.44,5.18 22.44,5.3  "
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "-0.12,5.77 -0.12,5.54 22.44,5.07 22.44,5.18  "
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "-0.12,5.66 -0.12,5.42 22.44,4.95 22.44,5.07  "
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "-0.12,5.54 -0.12,5.3 22.44,4.83 22.44,4.95  "
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "-0.12,5.42 -0.12,5.18 22.44,4.71 22.44,4.83  "
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "-0.12,5.3 -0.12,5.07 22.44,4.59 22.44,4.71  "
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "-0.12,5.18 -0.12,4.95 22.44,4.48 22.44,4.59  "
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "-0.12,5.07 -0.12,4.83 22.44,4.36 22.44,4.48  "
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "-0.12,4.95 -0.12,4.71 22.44,4.24 22.44,4.36  "
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "-0.12,4.83 -0.12,4.59 22.44,4.12 22.44,4.24  "
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "-0.12,4.71 -0.12,4.48 22.44,4 22.44,4.12  "
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "-0.12,4.59 -0.12,4.36 22.44,3.88 22.44,4  "
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "-0.12,4.48 -0.12,4.24 22.44,3.77 22.44,3.88  "
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "-0.12,4.36 -0.12,4.12 22.44,3.65 22.44,3.77  "
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "-0.12,4.24 -0.12,4 22.44,3.53 22.44,3.65  "
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "-0.12,4.12 -0.12,3.88 22.44,3.41 22.44,3.53  "
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "-0.12,4 -0.12,3.77 22.44,3.29 22.44,3.41  "
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "-0.12,3.88 -0.12,3.65 22.44,3.18 22.44,3.29  "
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "-0.12,3.77 -0.12,3.53 22.44,3.06 22.44,3.18  "
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "-0.12,3.65 -0.12,3.41 22.44,2.94 22.44,3.06  "
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "-0.12,3.53 -0.12,3.29 22.44,2.82 22.44,2.94  "
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "-0.12,3.41 -0.12,3.18 22.44,2.7 22.44,2.82  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M32.01,12.62h-4.13c0.12-4.96-1.89-8.15-4.37-10.16c-3.07-2.24-6.85-3.07-10.51-2.01 c-1.18,0.24-2.48,0.83-3.78,1.54c5.91,3.07,9.57,6.61,10.39,10.63h-3.9l8.15,8.03L32.01,12.62z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "31.77,-0.96 31.77,-0.01 9.21,0.46 9.21,-0.37  "
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "31.77,-0.13 31.77,0.11 9.21,0.58 9.21,0.34  "
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "31.77,-0.01 31.77,0.22 9.21,0.7 9.21,0.46  "
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "31.77,0.11 31.77,0.34 9.21,0.81 9.21,0.58  "
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "31.77,0.22 31.77,0.46 9.21,0.93 9.21,0.7  "
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "31.77,0.34 31.77,0.58 9.21,1.05 9.21,0.81  "
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "31.77,0.46 31.77,0.7 9.21,1.17 9.21,0.93  "
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "31.77,0.58 31.77,0.81 9.21,1.29 9.21,1.05  "
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "31.77,0.7 31.77,0.93 9.21,1.4 9.21,1.17  "
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "31.77,0.81 31.77,1.05 9.21,1.52 9.21,1.29  "
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "31.77,0.93 31.77,1.17 9.21,1.64 9.21,1.4  "
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "31.77,1.05 31.77,1.29 9.21,1.76 9.21,1.52  "
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "31.77,1.17 31.77,1.4 9.21,1.88 9.21,1.64  "
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "31.77,1.29 31.77,1.52 9.21,1.99 9.21,1.76  "
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "31.77,1.4 31.77,1.64 9.21,2.11 9.21,1.88  "
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "31.77,1.52 31.77,1.76 9.21,2.23 9.21,1.99  "
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "31.77,1.64 31.77,1.88 9.21,2.35 9.21,2.11  "
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "31.77,1.76 31.77,1.99 9.21,2.47 9.21,2.23  "
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "31.77,1.88 31.77,2.11 9.21,2.59 9.21,2.35  "
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "31.77,1.99 31.77,2.23 9.21,2.7 9.21,2.47  "
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "31.77,2.11 31.77,2.35 9.21,2.82 9.21,2.59  "
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "31.77,2.23 31.77,2.47 9.21,2.94 9.21,2.7  "
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "31.77,2.35 31.77,2.59 9.21,3.06 9.21,2.82  "
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "31.77,2.47 31.77,2.7 9.21,3.18 9.21,2.94  "
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "31.77,2.59 31.77,2.82 9.21,3.29 9.21,3.06  "
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "31.77,2.7 31.77,2.94 9.21,3.41 9.21,3.18  "
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "31.77,2.82 31.77,3.06 9.21,3.53 9.21,3.29  "
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "31.77,2.94 31.77,3.18 9.21,3.65 9.21,3.41  "
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "31.77,3.06 31.77,3.29 9.21,3.77 9.21,3.53  "
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "31.77,3.18 31.77,3.41 9.21,3.88 9.21,3.65  "
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "31.77,3.29 31.77,3.53 9.21,4 9.21,3.77  "
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "31.77,3.41 31.77,3.65 9.21,4.12 9.21,3.88  "
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "31.77,3.53 31.77,3.77 9.21,4.24 9.21,4  "
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "31.77,3.65 31.77,3.88 9.21,4.36 9.21,4.12  "
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "31.77,3.77 31.77,4 9.21,4.48 9.21,4.24  "
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "31.77,3.88 31.77,4.12 9.21,4.59 9.21,4.36  "
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "31.77,4 31.77,4.24 9.21,4.71 9.21,4.48  "
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "31.77,4.12 31.77,4.36 9.33,4.83 9.21,4.59  "
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "31.77,4.24 31.77,4.48 9.33,4.95 9.21,4.71  "
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "31.77,4.36 31.89,4.59 9.33,5.07 9.33,4.83  "
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "31.89,4.48 31.89,4.71 9.33,5.18 9.33,4.95  "
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "31.89,4.59 31.89,4.83 9.33,5.3 9.33,5.07  "
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "31.89,4.71 31.89,4.95 9.33,5.42 9.33,5.18  "
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "31.89,4.83 31.89,5.07 9.33,5.54 9.33,5.3  "
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "31.89,4.95 31.89,5.18 9.33,5.66 9.33,5.42  "
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "31.89,5.07 31.89,5.3 9.33,5.77 9.33,5.54  "
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "31.89,5.18 31.89,5.42 9.33,5.89 9.33,5.66  "
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st178",
    points: "31.89,5.3 31.89,5.54 9.33,6.01 9.33,5.77  "
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "31.89,5.42 31.89,5.66 9.33,6.13 9.33,5.89  "
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "31.89,5.54 31.89,5.77 9.33,6.25 9.33,6.01  "
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st181",
    points: "31.89,5.66 31.89,5.89 9.33,6.37 9.33,6.13  "
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st182",
    points: "31.89,5.77 31.89,6.01 9.33,6.48 9.33,6.25  "
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st183",
    points: "31.89,5.89 31.89,6.13 9.33,6.6 9.33,6.37  "
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "31.89,6.01 31.89,6.25 9.33,6.72 9.33,6.48  "
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "31.89,6.13 31.89,6.37 9.33,6.84 9.33,6.6  "
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "31.89,6.25 31.89,6.48 9.33,6.96 9.33,6.72  "
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "31.89,6.37 31.89,6.6 9.33,7.07 9.33,6.84  "
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "31.89,6.48 31.89,6.72 9.33,7.19 9.33,6.96  "
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "31.89,6.6 31.89,6.84 9.33,7.31 9.33,7.07  "
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st188",
    points: "31.89,6.72 31.89,6.96 9.33,7.43 9.33,7.19  "
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st189",
    points: "31.89,6.84 31.89,7.07 9.33,7.55 9.33,7.31  "
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "31.89,6.96 31.89,7.19 9.33,7.66 9.33,7.43  "
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "31.89,7.07 31.89,7.31 9.33,7.78 9.33,7.55  "
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st191",
    points: "31.89,7.19 31.89,7.43 9.33,7.9 9.33,7.66  "
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "31.89,7.31 31.89,7.55 9.33,8.02 9.33,7.78  "
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "31.89,7.43 31.89,7.66 9.33,8.14 9.33,7.9  "
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "31.89,7.55 31.89,7.78 9.33,8.25 9.33,8.02  "
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "31.89,7.66 31.89,7.9 9.33,8.37 9.33,8.14  "
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "31.89,7.78 31.89,8.02 9.33,8.49 9.33,8.25  "
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "31.89,7.9 31.89,8.14 9.33,8.61 9.33,8.37  "
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "31.89,8.02 31.89,8.25 9.33,8.73 9.33,8.49  "
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "31.89,8.14 31.89,8.37 9.33,8.85 9.33,8.61  "
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "31.89,8.25 31.89,8.49 9.33,8.96 9.33,8.73  "
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "31.89,8.37 31.89,8.61 9.33,9.08 9.33,8.85  "
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "31.89,8.49 31.89,8.73 9.33,9.2 9.33,8.96  "
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "31.89,8.61 31.89,8.85 9.33,9.32 9.33,9.08  "
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "31.89,8.73 31.89,8.96 9.33,9.44 9.33,9.2  "
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "31.89,8.85 31.89,9.08 9.33,9.55 9.33,9.32  "
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st203",
    points: "31.89,8.96 31.89,9.2 9.33,9.67 9.33,9.44  "
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "31.89,9.08 31.89,9.32 9.33,9.79 9.33,9.55  "
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "31.89,9.2 31.89,9.44 9.33,9.91 9.33,9.67  "
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "31.89,9.32 31.89,9.55 9.33,10.03 9.33,9.79  "
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "31.89,9.44 31.89,9.67 9.33,10.14 9.33,9.91  "
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "31.89,9.55 31.89,9.79 9.45,10.26 9.33,10.03  "
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "31.89,9.67 31.89,9.91 9.45,10.38 9.33,10.14  "
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "31.89,9.79 32.01,10.03 9.45,10.5 9.45,10.26  "
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "32.01,9.91 32.01,10.14 9.45,10.62 9.45,10.38  "
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "32.01,10.03 32.01,10.26 9.45,10.74 9.45,10.5  "
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "32.01,10.14 32.01,10.38 9.45,10.85 9.45,10.62  "
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "32.01,10.26 32.01,10.5 9.45,10.97 9.45,10.74  "
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "32.01,10.38 32.01,10.62 9.45,11.09 9.45,10.85  "
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "32.01,10.5 32.01,10.74 9.45,11.21 9.45,10.97  "
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "32.01,10.62 32.01,10.85 9.45,11.33 9.45,11.09  "
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st215",
    points: "32.01,10.74 32.01,10.97 9.45,11.44 9.45,11.21  "
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st216",
    points: "32.01,10.85 32.01,11.09 9.45,11.56 9.45,11.33  "
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st217",
    points: "32.01,10.97 32.01,11.21 9.45,11.68 9.45,11.44  "
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "32.01,11.09 32.01,11.33 9.45,11.8 9.45,11.56  "
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "32.01,11.21 32.01,11.44 9.45,11.92 9.45,11.68  "
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "32.01,11.33 32.01,11.56 9.45,12.03 9.45,11.8  "
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "32.01,11.44 32.01,11.68 9.45,12.15 9.45,11.92  "
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "32.01,11.56 32.01,11.8 9.45,12.27 9.45,12.03  "
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "32.01,11.68 32.01,11.92 9.45,12.39 9.45,12.15  "
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "32.01,11.8 32.01,12.03 9.45,12.51 9.45,12.27  "
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "32.01,11.92 32.01,12.15 9.45,12.62 9.45,12.39  "
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "st224",
    points: "32.01,12.03 32.01,12.27 9.45,12.74 9.45,12.51  "
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "st225",
    points: "32.01,12.15 32.01,12.39 9.45,12.86 9.45,12.62  "
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "st226",
    points: "32.01,12.27 32.01,12.51 9.45,12.98 9.45,12.74  "
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "st226",
    points: "32.01,12.39 32.01,12.62 9.45,13.1 9.45,12.86  "
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "st227",
    points: "32.01,12.51 32.01,12.74 9.45,13.22 9.45,12.98  "
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "32.01,12.62 32.01,12.86 9.45,13.33 9.45,13.1  "
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "st229",
    points: "32.01,12.74 32.01,12.98 9.45,13.45 9.45,13.22  "
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "32.01,12.86 32.01,13.1 9.45,13.57 9.45,13.33  "
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "32.01,12.98 32.01,13.22 9.45,13.69 9.45,13.45  "
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "st231",
    points: "32.01,13.1 32.01,13.33 9.45,13.81 9.45,13.57  "
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "st232",
    points: "32.01,13.22 32.01,13.45 9.45,13.92 9.45,13.69  "
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "st233",
    points: "32.01,13.33 32.01,13.57 9.45,14.04 9.45,13.81  "
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "st234",
    points: "32.01,13.45 32.01,13.69 9.45,14.16 9.45,13.92  "
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "st234",
    points: "32.01,13.57 32.01,13.81 9.45,14.28 9.45,14.04  "
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "st235",
    points: "32.01,13.69 32.01,13.92 9.45,14.4 9.45,14.16  "
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "st236",
    points: "32.01,13.81 32.01,14.04 9.45,14.51 9.45,14.28  "
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "st236",
    points: "32.01,13.92 32.01,14.16 9.45,14.63 9.45,14.4  "
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "st237",
    points: "32.01,14.04 32.01,14.28 9.45,14.75 9.45,14.51  "
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "st237",
    points: "32.01,14.16 32.01,14.4 9.45,14.87 9.45,14.63  "
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "st238",
    points: "32.01,14.28 32.01,14.51 9.45,14.99 9.45,14.75  "
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "st239",
    points: "32.01,14.4 32.01,14.63 9.45,15.11 9.45,14.87  "
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "st239",
    points: "32.01,14.51 32.01,14.75 9.45,15.22 9.45,14.99  "
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "32.01,14.63 32.01,14.87 9.45,15.34 9.45,15.11  "
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "32.01,14.75 32.01,14.99 9.45,15.46 9.45,15.22  "
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    className: "st241",
    points: "32.01,14.87 32.01,15.11 9.45,15.58 9.45,15.34  "
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "32.01,14.99 32.01,15.22 9.57,15.7 9.45,15.46  "
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "32.01,15.11 32.13,15.34 9.57,15.81 9.57,15.58  "
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "32.01,15.22 32.13,15.46 9.57,15.93 9.57,15.7  "
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "32.13,15.34 32.13,15.58 9.57,16.05 9.57,15.81  "
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "32.13,15.46 32.13,15.7 9.57,16.17 9.57,15.93  "
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "32.13,15.58 32.13,15.81 9.57,16.29 9.57,16.05  "
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "32.13,15.7 32.13,15.93 9.57,16.4 9.57,16.17  "
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    className: "st245",
    points: "32.13,15.81 32.13,16.05 9.57,16.52 9.57,16.29  "
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    className: "st245",
    points: "32.13,15.93 32.13,16.17 9.57,16.64 9.57,16.4  "
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "32.13,16.05 32.13,16.29 9.57,16.76 9.57,16.52  "
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "32.13,16.17 32.13,16.4 9.57,16.88 9.57,16.64  "
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "32.13,16.29 32.13,16.52 9.57,16.99 9.57,16.76  "
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    className: "st247",
    points: "32.13,16.4 32.13,16.64 9.57,17.11 9.57,16.88  "
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    className: "st247",
    points: "32.13,16.52 32.13,16.76 9.57,17.23 9.57,16.99  "
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "32.13,16.64 32.13,16.88 9.57,17.35 9.57,17.11  "
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "32.13,16.76 32.13,16.99 9.57,17.47 9.57,17.23  "
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "32.13,16.88 32.13,17.11 9.57,17.59 9.57,17.35  "
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    className: "st249",
    points: "32.13,16.99 32.13,17.23 9.57,17.7 9.57,17.47  "
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    className: "st249",
    points: "32.13,17.11 32.13,17.35 9.57,17.82 9.57,17.59  "
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "32.13,17.23 32.13,17.47 9.57,17.94 9.57,17.7  "
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "32.13,17.35 32.13,17.59 9.57,18.06 9.57,17.82  "
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "32.13,17.47 32.13,17.7 9.57,18.18 9.57,17.94  "
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "32.13,17.59 32.13,17.82 9.57,18.29 9.57,18.06  "
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "32.13,17.7 32.13,17.94 9.57,18.41 9.57,18.18  "
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "32.13,17.82 32.13,18.06 9.57,18.53 9.57,18.29  "
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "32.13,17.94 32.13,18.18 9.57,18.65 9.57,18.41  "
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "32.13,18.06 32.13,18.29 9.57,18.77 9.57,18.53  "
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "32.13,18.18 32.13,18.41 9.57,18.88 9.57,18.65  "
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "32.13,18.29 32.13,18.53 9.57,19 9.57,18.77  "
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "32.13,18.41 32.13,18.65 9.57,19.12 9.57,18.88  "
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "32.13,18.53 32.13,18.77 9.57,19.24 9.57,19  "
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "32.13,18.65 32.13,18.88 9.57,19.36 9.57,19.12  "
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "32.13,18.77 32.13,19 9.57,19.48 9.57,19.24  "
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "32.13,18.88 32.13,19.12 9.57,19.59 9.57,19.36  "
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "32.13,19 32.13,19.24 9.57,19.71 9.57,19.48  "
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "32.13,19.12 32.13,19.36 9.57,19.83 9.57,19.59  "
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "32.13,19.24 32.13,19.48 9.57,19.95 9.57,19.71  "
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    className: "st257",
    points: "32.13,19.36 32.13,19.59 9.57,20.07 9.57,19.83  "
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    className: "st257",
    points: "32.13,19.48 32.13,19.71 9.57,20.18 9.57,19.95  "
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "32.13,19.59 32.13,19.83 9.57,20.3 9.57,20.07  "
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "32.13,19.71 32.13,19.95 9.57,20.42 9.57,20.18  "
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "32.13,19.83 32.13,20.07 9.57,20.54 9.57,20.3  "
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "32.13,19.95 32.13,20.18 9.57,20.66 9.57,20.42  "
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "32.13,20.07 32.13,20.3 9.57,20.77 9.57,20.54  "
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "32.13,20.18 32.13,20.42 9.57,20.89 9.57,20.66  "
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "32.13,20.3 32.13,20.54 9.69,21.01 9.57,20.77  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmca);
export default __webpack_public_path__ + "static/media/AMCA.8be8334b75fd9df91271468954e4de5a.svg";
export { ForwardRef as ReactComponent };